import { SpecificType } from '@/constants/enum';
import { formatDateToYearMonthDayDateString } from '@/utils';
import { Button, DatePicker, Popover } from '@shopify/polaris';
import { CalendarIcon } from '@shopify/polaris-icons';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

type DateRange = {
  start: Date;
  end: Date;
};

type SpecificDatePickerProps = {
  dateRange: DateRange | undefined;
  setDateRange: React.Dispatch<
    React.SetStateAction<
      | {
          start: Date;
          end: Date;
        }
      | undefined
    >
  >;
  type?: SpecificType;
};

const SpecificDatePicker = ({ dateRange, setDateRange, type = SpecificType.SPECIFIC }: SpecificDatePickerProps) => {
  const { t } = useTranslation('shippingSettings');
  const [selectDate, setSelectDate] = useState<string>('');
  const [popoverActive, setPopoverActive] = useState(false);
  const [{ month, year }, setDate] = useState({
    month: new Date().getMonth(),
    year: new Date().getFullYear(),
  });
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const currentSection = type === SpecificType.SPECIFIC ? 'specificDate' : 'blackoutDate';

  const handleChangeDateRange = (range: DateRange) => {
    setDateRange(range);
  };

  const handleMonthChange = (month: number, year: number) => {
    setDate({ month, year });
  };

  const togglePopoverActive = () => setPopoverActive((popoverActive) => !popoverActive);

  const activator = (
    <Button onClick={togglePopoverActive} icon={CalendarIcon} fullWidth textAlign="left">
      {selectDate ? selectDate : t(`${currentSection}.actions.selectDate`)}
    </Button>
  );

  useEffect(() => {
    if (dateRange) {
      const convertStartDate = formatDateToYearMonthDayDateString(dateRange.start);
      const convertEndDate = formatDateToYearMonthDayDateString(dateRange.end);
      if (convertStartDate === convertEndDate) {
        setSelectDate(convertStartDate);
      } else {
        setSelectDate(`${convertStartDate} - ${convertEndDate}`);
      }
    } else {
      setSelectDate('');
    }
  }, [dateRange]);

  return (
    <>
      <Popover active={popoverActive} activator={activator} autofocusTarget="first-node" onClose={togglePopoverActive} fullWidth>
        <Popover.Pane fixed sectioned>
          <DatePicker
            month={month}
            year={year}
            onChange={handleChangeDateRange}
            onMonthChange={handleMonthChange}
            selected={dateRange}
            allowRange
            disableDatesBefore={today}
          />
        </Popover.Pane>
      </Popover>
    </>
  );
};

export default SpecificDatePicker;
